{
  "Accessibility Menu": "የተደረሰ ምናሌ",
  "Reset settings": "ቅንብሮችን ዳግም አስጀምር",
  "Close": "ዝጋ",
  "Content Adjustments": "የይዘት ማስተካከያዎች",
  "Adjust Font Size": "የፊደል መጠን አስተካክል",
  "Highlight Title": "ርዕስን አበራ",
  "Highlight Links": "አገናኞችን አበራ",
  "Readable Font": "ተነባቢ ፊደል",
  "Color Adjustments": "የቀለም ማስተካከያዎች",
  "Dark Contrast": "ጨለማ መለያየት",
  "Light Contrast": "ብርሃን መለያየት",
  "High Contrast": "ከፍተኛ መለያየት",
  "High Saturation": "ከፍተኛ መጠን ያለው ቀለም",
  "Low Saturation": "ዝቅተኛ መጠን ያለው ቀለም",
  "Monochrome": "አንደኛ ቀለም",
  "Tools": "መሳሪያዎች",
  "Reading Guide": "የንባብ መመሪያ",
  "Stop Animations": "አንዲሶችን አቁም",
  "Big Cursor": "ትልቅ አዝራር",
  "Increase Font Size": "የፊደል መጠን አሳድግ",
  "Decrease Font Size": "የፊደል መጠን አሳንስ",
  "Letter Spacing": "የፊደል ክፍተት",
  "Line Height": "የመስመር ከፍታ",
  "Font Weight": "የፊደል ክብደት",
  "Dyslexia Font": "የዲስሌክሲያ ፊደል",
  "Language": "ቋንቋ",
  "Open Accessibility Menu": "የተደረሰ ምናሌን ክፈት"
}
